export default function resetSliderValues() {
  var id = $(".tabs-nav .apptus-tab.active").attr("id");
  if ($('.discount-link').hasClass('active')) {
    id = "SO_PLO2";
  }
  if (id == "SO_PRICE" || id == 'SO_PLO2') {
    window.maxPriceFacetValue = 0;
    window.minPriceFacetValue = 0;
    $('#min_range').val(0);
    $('#max_range').val(0);
  }
}